// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1ocKD","label":"Section_label__2_wm5","contentWrap":"Section_contentWrap__2aLAT","footer":"Section_footer__bL18r","footerInner":"Section_footerInner__djd0B"};